var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResursiAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#fa7268;}.cls-3{fill:#6e5dd8;}.cls-4{fill:#aa6276;}.cls-5{fill:#159497;}.cls-6,.cls-7{fill:none;stroke-miterlimit:10;stroke-width:1.5px;}.cls-6{stroke:#000;stroke-linecap:round;}.cls-7{stroke:#fa7268;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.61,181.73c-5.41,11.44-8.37,18.16-8.7,30.81-.52,20.07,8,30.41,21.73,35s35.62,4.22,50.06,3.77l93.21-2.85c9.06-.28,18.6-.69,26.3-5.47,10-6.21,14.67-18.71,14.52-30.47s-4.34-23.06-8.61-34c-8.5-21.79-17.7-43.68-32.16-62.06s-35-33.12-58.21-35.85C246.63,73.78,225.88,141,206.61,181.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 95.76,
    cy: 253.28,
    r: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 433.65,
    y: 42.88,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "487.21 233.29 478.27 248.78 496.15 248.78 487.21 233.29"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.01,
    cy: 128.97,
    r: 67.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.39,130.53H371V100.36A66.24,66.24,0,0,0,304.82,34.2h-9.61a66.24,66.24,0,0,0-66.16,66.16v30.17h-9.41V100.36a75.65,75.65,0,0,1,75.57-75.57h9.61a75.65,75.65,0,0,1,75.57,75.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.01,
    cy: 128.97,
    r: 67.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.31,127.67a67.31,67.31,0,0,0-134.59,0A73.94,73.94,0,0,0,300,76.86,73.94,73.94,0,0,0,367.31,127.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186,302.87l25.17-58.21c10.8-25,34.22-41,60-41h58.12c25.92,0,49.44,16.17,60.16,41.35l24.62,57.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.01,
    cy: 136.22,
    r: 5.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.66,
    cy: 136.22,
    r: 5.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291,164.71a12.71,12.71,0,0,0,18,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 207.96,
    y: 94.48,
    width: 32.76,
    height: 72.1,
    rx: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 359.3,
    y: 94.48,
    width: 32.76,
    height: 72.1,
    rx: 15.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208,108.28h0a0,0,0,0,1,0,0v41.38a0,0,0,0,1,0,0h0a10.07,10.07,0,0,1-10.07-10.07V118.35A10.07,10.07,0,0,1,208,108.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.13,108.28h0a0,0,0,0,1,0,0v41.38a0,0,0,0,1,0,0h0a10.07,10.07,0,0,1-10.07-10.07V118.35A10.07,10.07,0,0,1,402.13,108.28Z",
    transform: "translate(794.2 257.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.28,113.77c12.26-5.3,15.43,2,27.7-3.25s9.09-12.64,21.35-17.94,15.44,2,27.7-3.26,9.09-12.64,21.36-17.94,15.44,2,27.7-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.28,158.66c12.26,5.3,15.43-2,27.7,3.26s9.09,12.64,21.35,17.94,15.44-2.05,27.7,3.25,9.09,12.64,21.36,17.94,15.44-2,27.7,3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M423.86,134.22c12.67,0,12.67,8,25.34,8s12.67-8,25.34-8,12.67,8,25.34,8,12.67-8,25.34-8,12.67,8,25.34,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.72,113.77c-12.26-5.3-15.43,2-27.7-3.25s-9.09-12.64-21.35-17.94-15.44,2-27.7-3.26S91.88,76.68,79.61,71.38s-15.44,2-27.7-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.72,158.66c-12.26,5.3-15.43-2-27.7,3.26s-9.09,12.64-21.35,17.94-15.44-2.05-27.7,3.25-9.09,12.64-21.36,17.94-15.44-2-27.7,3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.14,134.22c-12.67,0-12.67,8-25.34,8s-12.67-8-25.34-8-12.67,8-25.34,8-12.67-8-25.34-8-12.67,8-25.34,8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResursiAudio);
export default __webpack_public_path__ + "static/media/Resursi-audio.8ea8973812f71e3aac4a2ada744a82f3.svg";
export { ForwardRef as ReactComponent };